module.exports = __webpack_public_path__ + "img/katarina_events_18.d952cd14.jpg";